var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationQuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_22308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#2B7FD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52133 3.98063C6.92925 3.5727 7.46361 3.36827 7.99826 3.36733C8.53537 3.36639 9.07278 3.57082 9.48258 3.98063C9.89144 4.38949 10.0959 4.92537 10.0959 5.46126C10.0959 5.99714 9.89144 6.53302 9.48258 6.94188C9.07278 7.35168 8.53537 7.55611 7.99826 7.55517L7.99832 9.14317",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54995 12.1056C8.54995 11.8019 8.30371 11.5556 7.99995 11.5556C7.69619 11.5556 7.44995 11.8019 7.44995 12.1056C7.44995 12.4094 7.69619 12.6556 7.99995 12.6556C8.30371 12.6556 8.54995 12.4094 8.54995 12.1056Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_22308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationQuest);
export default __webpack_public_path__ + "static/media/notificationQuest.0d77faa66c1586037f7272a0dce5f0d9.svg";
export { ForwardRef as ReactComponent };